import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type TagStyles = {
  box: CSSProperties;
  background: {
    primary: CSSProperties;
    success: CSSProperties;
    warning: CSSProperties;
    error: CSSProperties;
    default: CSSProperties;
    transparent: CSSProperties;
    info: CSSProperties;
  };
  size: {
    small: CSSProperties;
    medium: CSSProperties;
    regular: CSSProperties;
  };
};

const styles: TagStyles = {
  box: {
    borderRadius: '4px',
    border: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: AppColors.VA.NEUTRALS._90_,
    overflow: 'hidden',
    width: 'max-content'
  },
  background: {
    primary: {
      backgroundColor: AppColors.VA.BACKGROUND._30_
    },
    success: {
      backgroundColor: AppColors.VA.SUCCESS._20_
    },
    warning: {
      backgroundColor: AppColors.VA.WARNING._20_
    },
    error: {
      backgroundColor: AppColors.VA.ERROR._20_
    },
    default: {
      backgroundColor: AppColors.VA.BACKGROUND._20_
    },
    info: {
      backgroundColor: AppColors.VA.INFO._10_
    },
    transparent: {
      backgroundColor: 'transparent'
    }
  },
  size: {
    small: {
      padding: '2px 6px'
    },
    medium: {
      padding: '6px 8px'
    },
    regular: {
      padding: '4px 12px'
    }
  }
};

export default styles;
